import type { SubscriptionPlanType } from "@/lib/api/types";
import { SUBSCRIPTION_PLAN_TYPE } from "@/lib/api/types";
import { keys } from "@/lib/i18n/portal";
import type { Tone } from "@/shared/rd";

/** How each plan type reads, its tag tone and its Doodle badge. */
const PLAN_TYPE: Record<SubscriptionPlanType, { label: string; tone: Tone; badge: string }> = {
  [SUBSCRIPTION_PLAN_TYPE.PREMIUM]: { label: keys.admin.tierPremium, tone: "blue", badge: "star" },
  [SUBSCRIPTION_PLAN_TYPE.FREE]: { label: keys.admin.tierFree, tone: "grey", badge: "package" },
  [SUBSCRIPTION_PLAN_TYPE.MONTHLY_SUBSCRIPTION]: { label: keys.admin.subscriptionPlanTypePaid, tone: "green", badge: "bill" },
  [SUBSCRIPTION_PLAN_TYPE.FREE_TRIAL]: { label: keys.admin.subscriptionPlanTypeFreeTrial, tone: "amber", badge: "clock" },
  [SUBSCRIPTION_PLAN_TYPE.PER_ORDER_CREDIT]: { label: keys.admin.subscriptionPlanTypePerOrderCredit, tone: "purple", badge: "currency" },
};

const FALLBACK = { label: keys.admin.subscriptionPlanTypePaid, tone: "grey" as Tone, badge: "bill" };

export function planTypeLabelKey(type: SubscriptionPlanType) {
  return (PLAN_TYPE[type] ?? FALLBACK).label;
}

export function planTypeTone(type: SubscriptionPlanType): Tone {
  return (PLAN_TYPE[type] ?? FALLBACK).tone;
}

export function planTypeBadge(type: SubscriptionPlanType) {
  return (PLAN_TYPE[type] ?? FALLBACK).badge;
}

/** The order the create/edit form lists the types in (unchanged). */
export const PLAN_TYPE_ORDER: SubscriptionPlanType[] = [
  SUBSCRIPTION_PLAN_TYPE.PREMIUM,
  SUBSCRIPTION_PLAN_TYPE.FREE,
  SUBSCRIPTION_PLAN_TYPE.MONTHLY_SUBSCRIPTION,
  SUBSCRIPTION_PLAN_TYPE.FREE_TRIAL,
  SUBSCRIPTION_PLAN_TYPE.PER_ORDER_CREDIT,
];

/** A per-order plan is a paid plan, so it lives behind the same filter. */
export function isPaidPlanType(type: SubscriptionPlanType) {
  return (
    type === SUBSCRIPTION_PLAN_TYPE.MONTHLY_SUBSCRIPTION ||
    type === SUBSCRIPTION_PLAN_TYPE.PER_ORDER_CREDIT ||
    type === SUBSCRIPTION_PLAN_TYPE.PREMIUM
  );
}

export function isFreePlanType(type: SubscriptionPlanType) {
  return type === SUBSCRIPTION_PLAN_TYPE.FREE_TRIAL || type === SUBSCRIPTION_PLAN_TYPE.FREE;
}
